import { DSControlledCheckbox } from '@elliemae/ds-controlled-form';
import { Grid } from '@elliemae/ds-grid';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoanHedged } from '../../../../../data/lockSummary/actions';
import {
  useHedgeLoanSelector,
  useRateSelectorLoan,
} from '../../../../../data/useSelectors';
import { setLoanDataValue } from '../../../../components/Form/utils/common';

export const HedgeLoanCheckbox = () => {
  const dispatch = useDispatch();
  const isLoanHedged = useRateSelectorLoan('hedged', '') as any;
  const hedgeLoanIndicator = useHedgeLoanSelector();
  const [hedgeCheckbox, setHedgeCheckbox] = useState();

  useEffect(() => {
    if (hedgeLoanIndicator === undefined || hedgeLoanIndicator === '') {
      setHedgeCheckbox(isLoanHedged);
      dispatch(setIsLoanHedged(isLoanHedged));
    } else {
      setHedgeCheckbox(hedgeLoanIndicator);
    }
  }, [isLoanHedged, hedgeLoanIndicator]);

  const handleOnHedgeChange = () => {
    dispatch(setIsLoanHedged(!hedgeLoanIndicator));
    dispatch(
      setLoanDataValue(
        !hedgeLoanIndicator ? 'Y' : 'N',
        'loanInformation.hedged',
      ) as any,
    );
  };

  return (
    <Grid>
      <DSControlledCheckbox
        data-testid="custom-data-testid"
        checked={hedgeCheckbox ?? false}
        name="hedgeLoan"
        label="Hedge Loan"
        id="hedgeLoan"
        onChange={handleOnHedgeChange}
      />
    </Grid>
  );
};
